import { BASE_URL_WITHOUT_PORT } from '@/shared/api/constants';

import { OnscreenJob } from '../types';

// The result link comes as a path on our host, like the other project media. Fields a service without the progress
// details does not send yet get their empty values.
export const adaptOnscreenJob = (job: OnscreenJob): OnscreenJob => {
  const adapted: OnscreenJob = {
    ...job,
    activity: job.activity ?? [],
    draft: job.draft ?? null,
    eta_seconds: job.eta_seconds ?? null,
    queue_position: job.queue_position ?? null,
  };

  if (!adapted.result_url?.startsWith('/')) {
    return adapted;
  }

  return { ...adapted, result_url: BASE_URL_WITHOUT_PORT + adapted.result_url };
};
